if (!customElements.get('trust-bar-slider')) {
  class TrustBarSlider extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('.trust-bar__track-wrapper');
      this.track   = this.querySelector('.trust-bar__track');
      this.items   = this.querySelectorAll('.trust-bar__item');
      this.current = 0;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));

      window.addEventListener('resize', () => this.onResize());
    }

    get pages() {
      return Math.ceil(this.items.length / 2);
    }

    get isMobile() {
      return window.innerWidth < 750;
    }

    go(dir) {
      if (!this.isMobile) return;
      this.current = (this.current + dir + this.pages) % this.pages;
      this.track.style.transform = `translateX(-${this.current * this.wrapper.offsetWidth}px)`;
    }

    onResize() {
      if (!this.isMobile) {
        this.current = 0;
        this.track.style.transform = '';
      } else {
        this.track.style.transform = `translateX(-${this.current * this.wrapper.offsetWidth}px)`;
      }
    }
  }

  customElements.define('trust-bar-slider', TrustBarSlider);
}
